import { AbilityBuilder } from "@casl/ability";
import { AppAbility } from "./define-permissions";

export const securityContextPermissions = (builder: AbilityBuilder<AppAbility>) => {
  const { can } = builder;

  can("read", "Reservations");

  can("read", "ParkingSpots");

  can("read", "Sites");

  can("update", "Password");

  can("send", "Contact");

  can("downloadXls", "ParkingSpots");

  can("authorizeAccess", "Reservations");
};
